if (!customElements.get('product-ring-size-engraving')) {
  class ProductRingSizeEngraving extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.maxChars = Number(this.dataset.maxChars || 20);
      this.sizeEmptyLabel =
        this.querySelector('[data-rse-open="size"] [data-rse-size-display]')?.textContent?.trim() ||
        'Select Size';
      this.emptyLabel =
        this.querySelector('[data-rse-engraving-display]')?.textContent?.trim() || 'Add Engraving';
      this.selectedFont = this.querySelector('.engraving-font-pill.is-active')?.dataset.rseFont || '';
      this.selectedFontFamily =
        this.querySelector('.engraving-font-pill.is-active')?.dataset.rseFontFamily || '';
      this.selectedFontTransform =
        this.querySelector('.engraving-font-pill.is-active')?.dataset.rseFontTransform || 'none';

      this.onDocClick = this.onDocClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.querySelectorAll('[data-rse-open]').forEach((btn) => {
        btn.addEventListener('click', () => this.openModal(btn.dataset.rseOpen));
      });

      this.querySelectorAll('[data-rse-close]').forEach((btn) => {
        btn.addEventListener('click', () => this.closeModals());
      });

      this.querySelectorAll('[data-rse-modal]').forEach((modal) => {
        modal.addEventListener('click', (event) => {
          if (event.target === modal) this.closeModals();
        });
      });

      this.querySelectorAll('[data-rse-size-value]').forEach((pill) => {
        pill.addEventListener('click', () => this.selectSize(pill));
      });

      this.querySelectorAll('[data-rse-font]').forEach((pill) => {
        pill.addEventListener('click', () => this.selectFont(pill));
      });

      const input = this.querySelector('[data-rse-engraving-input]');
      if (input) {
        input.addEventListener('input', () => this.syncPreview());
      }

      this.querySelector('[data-rse-engraving-done]')?.addEventListener('click', () => {
        this.commitEngraving();
        this.closeModals();
      });

      this.querySelector('[data-rse-engraving-clear]')?.addEventListener('click', () => {
        this.clearEngraving();
      });

      this.syncPreview();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick, true);
      document.removeEventListener('keydown', this.onKeydown);
    }

    openModal(name) {
      const modal = this.querySelector(`[data-rse-modal="${name}"]`);
      if (!modal) return;
      this.closeModals();
      modal.hidden = false;
      requestAnimationFrame(() => modal.classList.add('is-open'));
      document.documentElement.classList.add('rse-modal-open');
      document.addEventListener('keydown', this.onKeydown);
      const focusable = modal.querySelector('input, button');
      focusable?.focus();
    }

    closeModals() {
      this.querySelectorAll('[data-rse-modal]').forEach((modal) => {
        modal.classList.remove('is-open');
        window.setTimeout(() => {
          if (!modal.classList.contains('is-open')) modal.hidden = true;
        }, 220);
      });
      document.documentElement.classList.remove('rse-modal-open');
      document.removeEventListener('keydown', this.onKeydown);
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.closeModals();
    }

    onDocClick() {}

    selectSize(pill) {
      const value = pill.dataset.rseSizeValue || '';
      this.querySelectorAll('[data-rse-size-value]').forEach((el) => {
        const active = el === pill;
        el.classList.toggle('is-selected', active);
        el.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const display = this.querySelector('[data-rse-size-display]');
      if (display) display.textContent = value || this.sizeEmptyLabel;

      const trigger = this.querySelector('[data-rse-open="size"]');
      trigger?.classList.toggle('selected', Boolean(value));

      const prop = this.querySelector('[data-rse-size-property]');
      if (prop) prop.value = value;

      this.closeModals();
    }

    selectFont(pill) {
      this.querySelectorAll('[data-rse-font]').forEach((el) => {
        el.classList.toggle('is-active', el === pill);
      });
      this.selectedFont = pill.dataset.rseFont || '';
      this.selectedFontFamily = pill.dataset.rseFontFamily || '';
      this.selectedFontTransform = pill.dataset.rseFontTransform || 'none';
      this.syncPreview();
    }

    syncPreview() {
      const input = this.querySelector('[data-rse-engraving-input]');
      const preview = this.querySelector('[data-rse-preview-text]');
      const counter = this.querySelector('[data-rse-counter]');
      const text = (input?.value || '').slice(0, this.maxChars);

      if (input && input.value !== text) input.value = text;
      if (counter) counter.textContent = `${text.length}/${this.maxChars}`;
      if (preview) {
        preview.textContent = text;
        preview.style.fontFamily = this.selectedFontFamily || '';
        preview.style.textTransform = this.selectedFontTransform || 'none';
      }
    }

    commitEngraving() {
      const input = this.querySelector('[data-rse-engraving-input]');
      const text = (input?.value || '').trim().slice(0, this.maxChars);
      const display = this.querySelector('[data-rse-engraving-display]');
      const trigger = this.querySelector('[data-rse-open="engraving"]');
      const textProp = this.querySelector('[data-rse-engraving-property]');
      const fontProp = this.querySelector('[data-rse-font-property]');

      if (textProp) textProp.value = text;
      if (fontProp) fontProp.value = text ? this.selectedFont : '';

      if (display) {
        display.textContent = text ? `“${text}”` : this.emptyLabel;
      }
      trigger?.classList.toggle('set', Boolean(text));
    }

    clearEngraving() {
      const input = this.querySelector('[data-rse-engraving-input]');
      if (input) input.value = '';
      this.syncPreview();
      this.commitEngraving();
      this.closeModals();
    }
  }

  customElements.define('product-ring-size-engraving', ProductRingSizeEngraving);
}
